<template>
  <div class="previous-page">
    <div class="previous-header" v-if="$route.query.isApp!=1">
      <i
        @click="$router.go(-1)"
        class="iconfont icon-left"
        :class="{mirrorRotateLevel:isDirection}"
      ></i>
    </div>
    <div class="previous-body">
      <p class="previous-title bold">{{$t('300335')}}</p>
      <van-list
        offset="50"
        v-model="loading"
        :finished="finished"
        loading-text=" "
        finished-text=" "
        @load="onLoad"
        v-if="takeNotes.length>0"
      >
        <div class="previous-item" v-for="item in takeNotes" :key="item.id">
          <p class="Number-of-periods">
            <span class="bold">{{$t('300343',{num:item.roundCount})}}</span>
          </p>
          <p class="Snap-purchase-user">
            <span>{{$t('300340')}}</span>
            <span>{{item.nickname}}</span>
          </p>
          <p class="buyCount">
            <span>{{$t('300323')}}</span>
            <span>
              <em>{{item.buyCount}}&nbsp;</em>{{$t('300306')}}
            </span>
          </p>
          <p class="announceTime">
            <span>{{$t('300341')}}</span>
            <span>{{parseTime(item.createTime)}}</span>
          </p>
        </div>
      </van-list>
      <div class="previous-nodata" v-else>
        <van-empty :description="$t('300108')">
            <svg slot="image" class="icon empty-icon" aria-hidden="true">
              <use xlink:href="#icon-jilu1" />
            </svg>
          </van-empty>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { parseTime } from '../../utils'
import { List,Empty} from 'vant'
import {getPrizeHistory} from './api'
export default {
  components: {
    VanList: List,
    VanEmpty:Empty
  },
  data() {
    return {
      loading: false,
      finished: false,
      total: 0,
      ind: 1,
      num: 10,
      takeNotes:[]
    }
  },
  computed: {
    ...mapGetters(['isDirection'])
  },
  created(){
    this.getPrizeHistory()
  },
  methods: {
    getPrizeHistory(){
      getPrizeHistory({mallProductId:this.$route.query.mallProductId,page:this.ind}).then(res=>{
       this.takeNotes = res.data.items;
       this.total = res.data.total
      })
    },
    parseTime(time, type) {
      return parseTime(time, type)
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      this.loading = true;
      setTimeout(() => {
        if (this.takeNotes.length === this.total) {
          this.finished = true;
           this.loading = false;
          return
        }
        this.ind++;
        getPrizeHistory({mallProductId:this.$route.query.mallProductId,page:this.ind}).then(res=>{
           this.takeNotes = this.takeNotes.concat(res.data.items)
      })
        // 加载状态结束
        this.loading = false;
        // 数据全部加载完成

      }, 1000);
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/variableName";
@import "../../style/mixin";
[dir="ltr"] .previous-header {
  i {
    float: left;
  }
}
[dir="rtl"] .previous-header {
  i {
    float: right;
  }
}
.previous-page {
  background: #f6f8fa;
  height: 100%;
  width: 100%;
  position: fixed;

  .previous-header {
    width: 100%;
    height: torem(44);
    line-height: torem(44);
    background: #fff;
    padding: 0 torem(16);
    box-sizing: border-box;
    i {
      font-size: torem(18);
    }
  }
  .previous-body {
    height: 100%;
    overflow-y: auto;
    padding: torem(24) torem(16);
    padding-bottom: torem(48);
    .previous-title {
      color: #333333;
      font-size: torem(18);
      line-height: torem(21);
      width: torem(343);
      margin: 0 auto;
      margin-bottom: torem(16);
    }
    .previous-item {
      width: torem(343);
      //   height: torem(131);
      box-shadow: torem(1) torem(1) torem(1) 0 rgba(0, 0, 0, 0.08);
      border-radius: torem(8);
      box-sizing: border-box;
      margin: 0 auto torem(8);
      background: #fff;
      padding: torem(16) torem(12);
      span {
        color: #7f8490;
        font-size: torem(12);
        line-height: torem(14);
      }
      .bold{
        color:#333333 ;
        font-size: torem(14);
        line-height: torem(21);
      }
      .Number-of-periods {
        // font-size: torem(14);
        margin-bottom: torem(12);
      }
      .Snap-purchase-user {
        display: flex;
        span {
          &:last-child {
            color: #f34e74;
          }
        }
      }
      .buyCount,
      .Number-of-periods,
      .Snap-purchase-user,
      .announceTime {
        display: flex;
        justify-content: space-between;
        align-content: center;
        margin-bottom: torem(12);
        em {
          color: #f34e74;
        }
      }
      .announceTime {
        margin-bottom: 0;
      }
    }
  }
}
.previous-nodata {
  width: 100%;
  // background: #fff;
  height: torem(400);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  // background: #ccc;
  /deep/ .van-empty__image {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: torem(60);

    svg {
      width: torem(47.42);
      height: torem(50);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/purchase/previousRecords.vue